import { createSelector } from 'reselect'
import { memoize } from '@exodus/basic-utils'
import { OrderSet } from '@exodus/models'

const selectorFactory = (allOrdersSelector) =>
  memoize((walletAccount) =>
    createSelector(allOrdersSelector, (orderSet) => {
      const filtered = [...orderSet].filter(({ fromWalletAccount, toWalletAccount }) =>
        [fromWalletAccount, toWalletAccount].includes(walletAccount)
      )
      return OrderSet.fromArray(filtered)
    })
  )

const createOrdersInAccountSelectorDefinition = {
  id: 'createOrdersInAccount',
  selectorFactory,
  dependencies: [{ selector: 'all' }],
}

export default createOrdersInAccountSelectorDefinition
